@if (product()) {
  <odx-content-box
    class="content-box flex-column"
    [ngClass]="{
      selected: selected,
      selectable: selectionMode() !== 'none',
    }"
    odxLayout="flex gap-none"
    (click)="onCardClicked()"
  >
    <odx-area-header class="header">
      <h6
        class="odx-heading-5 card-title"
        (click)="onTooltipClicked($event)"
        [odxTooltip]="product() | localizeProductName"
        [odxTooltipVisible]="tooltipVisible"
        [odxTooltipDisabled]="isTooltipDisabled()"
        odxTooltipSize="large"
      >
        {{ product() | localizeProductName | displayName }}
      </h6>
    </odx-area-header>
    <div class="h-100 content">
      <div class="image-wrapper">
        <app-product-image
          [product]="product()"
          [imageUrl]="imageUrl()"
          [fallbackImageUrl]="fallbackImageUrl()"
        ></app-product-image>
      </div>
      <ng-content></ng-content>
    </div>
    <odx-content-box-footer class="footer w-100">
      <div odxLayout="flex" class="space-between">
        <!-- do not propagate radio button click to prevent from multiple click events when card is clicked -->
        @if (selectionMode() === "single") {
          <odx-radio-button (click)="$event.stopPropagation()" [value]="product()" i18n="@@global.select"
            >Auswählen</odx-radio-button
          >
        }
        <!-- do not propagate checkbox click to prevent from multiple click events when card is clicked -->
        @if (selectionMode() === "multi") {
          <odx-checkbox
            (click)="$event.stopPropagation()"
            (checkedChange)="onCheckedChanged()"
            [checked]="selected"
            #checkbox
            i18n="@@global.select"
            >Auswählen</odx-checkbox
          >
        }
        @if (selectionMode() === "none") {
          <div></div>
        }
        <p>{{ showCosts() && priceData() ? (priceData()!.price | currency: priceData()!.currencyCode) : "" }}</p>
      </div>
    </odx-content-box-footer>
  </odx-content-box>
}
